<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
    :max-width="550"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Profile</span>
    </template>
    <template slot="body">
      <div class="d-flex flex-column">
        <div class="d-flex flex-column">
          <span
            style="color: #000; font-size: 16px;"
            class="fw500 pb-1"
          >Code<RedAsterisk /></span>
          <v-text-field
            v-model="item.code"
            outlined
            dense
            placeholder="Enter Code"
            :rules="[(v) => !!v || 'Code is required']"
          />
        </div>

        <div class="d-flex flex-column">
          <span
            style="color: #000; font-size: 16px;"
            class="fw500 pb-1"
          >Image</span>
          <v-file-input
            v-model="item.image"
            outlined
            dense
            accept="image/*"
            placeholder="Enter Image"
          />
        </div>
      </div>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      code: null,
      image: null,
    },
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.profile.read(submitModel);
      if (!res || res.length < 1 || !res[0]) return;
      const firstIndex = 0;
      this.item = res[firstIndex];
    },

    async submit() {
      if (!this.item) return false;
      const formData = new FormData();
      if (this.item.id) formData.append('id', this.item.id);
      formData.append('code', this.item.code);
      if (this.item.image) formData.append('image', this.item.image);
      let res;
      if (this.item.id) {
        res = await this.$api.profile.store(formData, 'update');
      } else {
        res = await this.$api.profile.store(formData);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(id) {
      if (id) {
        this.item.id = id;
        this.get(id);
      } else {
        this.item = { ...this.itemDto };
      }
      this.$refs.dialogBox.open();
    },
  },
};
</script>
